<template>
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
			</div>
			<div class="pull-right">
				<b-button v-if="$route.params.action === 'checking' && $can('change', 'warehouse-docStatus')" variant="success" class="mr-2" @click="saveAndFinishDoc">
					{{ $t('save-finish') }}
				</b-button>
				<b-button style="background-color: #9cf165" class="mr-2" @click="check" v-if="$route.params.action === 'checking'">
					<i class="fa fa-check"></i> {{ $t('checking') }}
				</b-button>
				<b-button variant="outline-dark" @click="submitPricePrint" class="mr-2">
					<i class="fa fa-print"></i> {{ $t('incomes.create.prices')}}
				</b-button>
				<b-button variant="outline-dark" @click="submitBarcodePrint" class="mr-2">
					<i class="fa fa-print"></i> {{ $t('goods.barcode')}}
				</b-button>
				<b-button variant="outline-dark" @click="print" class="mr-2">
					<i class="fa fa-print"/> {{ $t('Печать') }}
				</b-button>
			</div>
		</div>
		<br>
		<br>
		<div class="doc-body">
			<b-card class="p-1">
				<b-row>
					<b-col cols="4">

					</b-col>
					<b-col cols="4">
						<h5 style="text-align: center"><b>Приходная накладная</b></h5>
					</b-col>
					<b-col cols="4">
						<p style="text-align: right"></p>
					</b-col>
				</b-row>
				<br>
				<div v-if="checked" style="line-height: 5px">
					<b-row>
						<b-col cols="6">
							<b-row>
								<b-col cols="3">
									<p>Накладная :</p>
								</b-col>
								<b-col>
									<b>{{ item.regNumber }}</b>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="3">
									<p>Паставщик :</p>
								</b-col>
								<b-col>
									<b>{{ item.contragentName }}</b>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="3">
									<p>Куда :</p>
								</b-col>
								<b-col>
									<b>{{ item.toDepartmentName }}</b>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="3">
									<p>{{ $t('incomes.date') }} :</p>
								</b-col>
								<b-col>
									<b>{{ item.regDate }}</b>
								</b-col>
							</b-row>
						</b-col>
						<b-col cols="6" v-if="item.extraCostList && item.extraCostList.length > 0">
							<b-row v-for="(extraCost, index) in item.extraCostList" :key="`exttra-cost-${index}`">
								<b-col cols="5">
									<p>{{ extraCost.categoryName }} :</p>
								</b-col>
								<b-col>
									<b>{{ extraCost.currencyCost ? extraCost.currencyCost.toFixed(4) : '' }}</b> - <span>{{ extraCost.currencyName }}</span>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="5">
									<p>Итоговый доп.расход :</p>
								</b-col>
								<b-col>
									<b>{{ item.extraCosts ? item.extraCosts.toFixed(4) : '' }}</b> - <span>{{ item.toDepCurrencyName }}</span>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="5">
									<p>Сч/фактура поставщика :</p>
								</b-col>
								<b-col>
									<b>{{ item.reason }}</b>
								</b-col>
							</b-row>
							<b-row v-if="item.currencyName !== 'UZS'">
								<b-col cols="5">
									<p>Валюта ({{ item.currencyName }}) :</p>
								</b-col>
								<b-col>
									<b>{{ currencyRate(item.currencyName) }}</b> - <span>UZS</span>
								</b-col>
							</b-row>
						</b-col>
						<b-col v-else cols="6"/>
					</b-row>
				</div>
				<br>
				<div class="mb-2" id="nakladnoyTableWrapper">
					<div v-if="loading" class="text-center">
						<b-spinner small class="mr-2"/><strong>Loading...</strong>
					</div>
					<table class="table table-striped" id="tableForExcel">
						<tr>
							<th class="text-center">№</th>
							<th class="text-center">{{ $t('goods.special-barcode') }}</th>
							<th class="text-center">{{ $t('goods.name') }}</th>
							<th class="text-center">{{ $t('goods.barcode') }}</th>
<!--							<th class="text-center">{{ $t('kirim.expirationDate') }}</th>-->
							<th class="text-center">{{ $t('goods.inv-cent') }}</th>
							<th class="text-center">{{ $t('goods.kirim-cent') }}</th>
							<th class="text-center">{{ $t('goods.sale-cent') }}</th>
							<th class="text-center">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center">{{ $t('goods.invSumma') }}</th>
							<th class="text-center">{{ $t('goods.kirimCent') }}</th>
							<th class="text-center">{{ $t('goods.saleCent') }}</th>
						</tr>
						<template>
							<tr v-for="(i,index) in item.whItems" :key="i.id" :style="i.equal=='-'? 'background-color: #f67373':i.equal=='+'? 'background-color: #5AAFE8FF' :i.newCount==0? 'background-color: #8aee79': 'background-color: white'">
								<td width="1%" class="text-center">{{ index + 1 }}</td>
								<td width="5%">
									<p :style="i.error == '0' ? 'background-color: yellow' : 'background-color: white'" style="text-align: center">{{ i.barcode }}</p>
								</td>
								<td width="10%">
									<p>{{ i.itemName }}</p>
								</td>
								<td width="5%" class="text-center">
									<p v-for="barcode in i.multiBarcodesString"><span>{{ barcode }}</span><br></p>
								</td>
<!--								<td width="5%" class="text-center">-->
<!--									<p>{{ i.termOfItem }}</p>-->
<!--								</td>-->
								<td width="5%" class="text-center">
									<p>{{ i.incomingPriceUsd.toFixed(4) }}</p>
								</td>
								<td width="5%" class="text-center">
									<p>{{ i.selfExtraCosts ? (i.incomingPriceUzs + i.selfExtraCosts).toFixed(4) : i.incomingPriceUzs.toFixed(4) }}</p>
								</td>
								<td width="3%" class="text-center">
									<p v-if="i.priceUzs">{{ i.priceUzs.toFixed(4) }}</p>
									<p v-else-if="priceItems[index].currentPrice">{{ priceItems[index].currentPrice.toFixed(4) }}</p>
									<p v-else>0</p>
								</td>
								<td  width="3%">
									<p class="text-center small">{{ i.count }}
										<b-badge :variant="i.equal == '-' ? 'danger' : 'success'" v-if="i.newCount>0">
											{{ `${i.equal} ${i.newCount}` }}
										</b-badge>
										<i v-else-if="i.newCount == 0" class="fa fa-check text-success"></i>
									</p>
								</td>
								<td width="5%" class="text-center">
									<p>{{ (i.count * i.incomingPriceUsd).toFixed(4) }}</p>
								</td>
								<td width="5%" class="text-center">
									<p>{{ i.selfExtraCosts ? (((i.incomingPriceUzs) + i.selfExtraCosts) * i.count).toFixed(4) : (i.incomingPriceUzs * i.count).toFixed(4) }}</p>
								</td>
								<td width="5%" class="text-center">
									<p v-if="i.priceUzs">{{ (i.priceUzs * i.count).toFixed(4) }}</p>
									<p v-else-if="priceItems[index].currentPrice">{{ (priceItems[index].currentPrice * i.count).toFixed(4) }}</p>
									<p v-else>0</p>
								</td>
							</tr>
							<tr>
								<td colspan="7"><p class="text-right"><b>ИТОГО на сумму:</b></p></td>
								<td class="text-center"><b>{{ Count }}</b></td>
								<td class="text-center"><b>{{ IncomePriceUzs.toFixed(4) }}</b></td>
								<td class="text-center"><b>{{ plus.toFixed(4) }}</b></td>
								<td class="text-center"><b>{{ Price.toFixed(4) }}</b></td>
							</tr>
						</template>
					</table>
				</div>
				<div>
<!--					<b-row>-->
<!--						<b-col cols="3">-->
<!--							<p>Суммовой эквивалент (прод.суммы)</p>-->
<!--						</b-col>-->
<!--						<b-col cols="8">-->
<!--							<b>{{ (Price * currencyEur) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back'}) }} UZS</b>-->
<!--						</b-col>-->
<!--					</b-row>-->
<!--					<b-row>-->
<!--						<b-col cols="3">-->
<!--							<p>Сумма по инвойсной цене</p>-->
<!--						</b-col>-->
<!--						<b-col cols="8">-->
<!--							<b>{{ number_to_string(Math.abs(IncomePriceUzs.toFixed(2)), item.currencyName) ? number_to_string(Math.abs(IncomePriceUzs.toFixed(2)), item.currencyName) : 0 }}</b>-->
<!--						</b-col>-->
<!--					</b-row>-->
<!--					<b-row>-->
<!--						<b-col cols="3">-->
<!--							<p>Сумма по приходной цене</p>-->
<!--						</b-col>-->
<!--						<b-col cols="8">-->
<!--							<b>{{ number_to_string1(Math.abs(plus.toFixed(2))) ? number_to_string1(Math.abs(plus.toFixed(2))) : 0 }}</b>-->
<!--						</b-col>-->
<!--					</b-row>-->
<!--					<b-row>-->
<!--						<b-col cols="3">-->
<!--							<p>Сумма по продажной цене</p>-->
<!--						</b-col>-->
<!--						<b-col cols="8">-->
<!--							<b>{{ number_to_string1(Math.abs(Price.toFixed(2))) ? number_to_string1(Math.abs(Price.toFixed(2))) : 0 }}</b>-->
<!--						</b-col>-->
<!--					</b-row>-->
					<b-row class="mt-4">
						<b-col>
							<b>Сдал_________________________________________</b>
						</b-col>
						<b-col>
							<b>Руководитель______________________________</b>
						</b-col>
					</b-row>
					<b-row class="mt-4">
						<b-col>
							<b>Принял_______________________________________</b>
						</b-col>
						<b-col>
							<b>Гл.бухгалтер_________________________________</b>
						</b-col>
					</b-row>
					<b-row class="mt-4">
						<b-col>
							<b>Составил_______________________________________</b>
						</b-col>
						<b-col></b-col>
					</b-row>
				</div>
			</b-card>
			<b-form-file
				accept=".xlsx, xls"
				v-model="file"
				style="display: none"
				@change="processFile($event)"
				id="fileUpload"
			></b-form-file>
		</div>
	</div>
</template>

<script>
import WhDocument from "../../../../services/wh-document.service";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import {XlsxRead, XlsxJson} from "vue-xlsx/dist/vue-xlsx.es.js"
import XLSX from "xlsx"
import items from "../items";
import MyCurrencyInput from "../../../my-currency-input/my-currency-input";
import {mapActions} from "vuex";
export default {
	name: 'naklodnoyNew',
	components: {
		MyCurrencyInput,
		XlsxRead, XlsxJson,
		XlsxWorkbook,
		XlsxSheet,
		XlsxDownload
	},
	data() {
		return {
			regDate: null,
			prices: [],
			checked: true,
			loading: false,
			excelItem: [],
			Id:null,
			item: {
				whItems: []
			},
			priceItems: [],
			depId: null,
			file: null,
			totalItemSum: 0,
			dataForExcel: [],
			excelName: 'Excel sheet',
			search: {
				limit: 10,
				page: 1
			}
		}
	},
	computed: {
		// totalItemSum() {
		// let total = 0;
		// if (this.param.table.length) {
		// 	this.param.table.forEach(el => {
		// 		total += parseFloat(el.item_sum ? el.item_sum : 0);
		// 	})
		// }
		// return this.$roundToTwo(total)
		// },
		// total() {
		// 	return this.item.whItems.reduce((total, item) => {
		// 		return total + item.count
		// 	}, 0);
		// },
		Count() {
			let total = this.item.whItems.map(e => {
				return e.count
			});
			let sum = 0
			for (let i = 0; i < total.length; i++) {
				sum += parseFloat(total[i])
			}
			return sum
		},
		IncomePriceUzs() {
			let total = this.item.whItems.map(e => {
				return e.incomingPriceUsd * e.count
			});
			let sum = 0
			for (let i = 0; i < total.length; i++) {
				sum += parseFloat(total[i])
			}
			return sum
		},
		plus() {
			let total = this.item.whItems.map(e => {
				let s
				if (e.selfExtraCosts) {
					s = (e.incomingPriceUzs + e.selfExtraCosts) * e.count
				} else {
					s = e.incomingPriceUzs * e.count
				}
				return s
			});
			let sum = 0
			for (let i = 0; i < total.length; i++) {
				sum += parseFloat(total[i])
			}
			return sum
		},
		Price() {
			let price = false
			let total = this.item.whItems.map(e => {
				if (e.priceUzs) {
					let s = e.priceUzs * e.count
					price = true
					return s
				}
			});
			let total1 = this.priceItems.map(e => {
				if (e.currentPrice) {
					let t = e.currentPrice * e.count
					return t
				}
			});
			if (price) {
				let sum = 0
				for (let i = 0; i < total.length; i++) {
					sum += parseFloat(total[i])
				}
				return sum
			} else {
				let sum = 0
				for (let i = 0; i < total1.length; i++) {
					if (total1[i]) {
						sum += parseFloat(total1[i])
					}
				}
				return sum
			}
		},
		currencyEur() {
			let price = 0
			this.prices.forEach(r => {
				if (r.currencyId === 27) {
					price = r.rate
				}
			})
			return price
		}
	},
	methods: {
		...mapActions('warehouse', ['setPriceWhItems']),
		submitPricePrint() {
			let items = {};
			items.status = true;
			items.data = JSON.parse(JSON.stringify(this.item.whItems));
			items.data.forEach((item,index) => {
				items.data[index].count = parseInt(item.count)
			});
			this.setPriceWhItems(items);
			this.$router.push(`/warehouse-management/price/print`);
		},
		submitBarcodePrint() {
			this.$router.push(`/warehouse-management/income/barcode/${this.$route.params.id}`);
		},
		saveAndFinishDoc() {
			WhDocument.saveAndFinishIncomeDoc(this.$route.params.id).then(res => {
				this.goBackToFrom();
				this.$vs.notify({
					title: 'Success',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},
		check() {
			this.$router.push(`/warehouse-management/income/views/${this.Id}`)
		},
		currencyRate(name) {
			let price = 0
			this.prices.forEach(r => {
				if (name == r.currencyName) {
					price = r.rate
				}
			})
			return price
		},
		exportToExcel() {
			this.dataForExcel = []
			this.loaders = true
			setTimeout(async () => {
				await WhDocument.get(this.item.id).then(response => {
					for (let j = 0; j < response.data.whItems.length; j++) {
						let data = {
							'Спец-код': response.data.whItems[j].barcode,
							'Количество': response.data.whItems[j].count,
							'Продажная цена': response.data.whItems[j].currentPrice,
							'Новая приходная цена': response.data.whItems[j].newIncomePrice,
							'Новая продажная цена': response.data.whItems[j].priceUzs
						}
						this.dataForExcel.push(data)
					}
					this.loaders = false
				}).catch(error => {
					this.loaders = false
				})
			}, 1000);
		},
		addButton() {
			document.querySelector("#fileUpload").click()
		},
		get() {
			if (this.$can('get', 'warehouse-document')) {
				let data = {
					limit: 1000,
					page: 1,
					value: ''
				}
				return WhDocument.getWithPrices(this.$route.params.id, data).then(response => {
					this.item = response.data;
					this.Id = response.data.id
					this.sumPrice(this.item);
					this.sumIncome(this.item);
				}).catch(error => {
					// this.loader = false
				})
			}
		},
		number_to_string(_number, name) {
			let vm = this;
			var _arr_numbers = new Array();
			_arr_numbers[1] = new Array('',
				vm.$t('number_to_string.1'),
				vm.$t('number_to_string.2'),
				vm.$t('number_to_string.3'),
				vm.$t('number_to_string.4'),
				vm.$t('number_to_string.5'),
				vm.$t('number_to_string.6'),
				vm.$t('number_to_string.7'),
				vm.$t('number_to_string.8'),
				vm.$t('number_to_string.9'),
				vm.$t('number_to_string.10'),
				vm.$t('number_to_string.11'),
				vm.$t('number_to_string.12'),
				vm.$t('number_to_string.13'),
				vm.$t('number_to_string.14'),
				vm.$t('number_to_string.15'),
				vm.$t('number_to_string.16'),
				vm.$t('number_to_string.17'),
				vm.$t('number_to_string.18'),
				vm.$t('number_to_string.19'));

			_arr_numbers[2] = new Array('', '',
				vm.$t('number_to_string.20'),
				vm.$t('number_to_string.30'),
				vm.$t('number_to_string.40'),
				vm.$t('number_to_string.50'),
				vm.$t('number_to_string.60'),
				vm.$t('number_to_string.70'),
				vm.$t('number_to_string.80'),
				vm.$t('number_to_string.90')
			);
			_arr_numbers[3] = new Array('',
				vm.$t('number_to_string.100'),
				vm.$t('number_to_string.200'),
				vm.$t('number_to_string.300'),
				vm.$t('number_to_string.400'),
				vm.$t('number_to_string.500'),
				vm.$t('number_to_string.600'),
				vm.$t('number_to_string.700'),
				vm.$t('number_to_string.800'),
				vm.$t('number_to_string.900'),
			);

			function number_parser(_num, _desc) {
				var _string = '';
				var _num_hundred = '';
				if (_num.length == 3) {
					_num_hundred = _num.substr(0, 1);
					_num = _num.substr(1, 3);
					_string = _arr_numbers[3][_num_hundred] + ' ';
				}
				if (_num < 20) _string += _arr_numbers[1][parseFloat(_num)] + ' ';
				else {
					var _first_num = _num.substr(0, 1);
					var _second_num = _num.substr(1, 2);
					_string += _arr_numbers[2][_first_num] + ' ' + _arr_numbers[1][_second_num] + ' ';
				}
				switch (_desc) {
					case 0:
						var _last_num = parseFloat(_num.substr(-1));
						// if (_last_num == 1) _string += vm.$t('number_to_string.currency1');
						// else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.currency2');
						// else _string += vm.$t('number_to_string.currency3');
						break;
					case 1:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.thousand1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.thousand2');
						else _string += vm.$t('number_to_string.thousand3');
						_string = _string.replace(vm.$t('number_to_string.one1'), vm.$t('number_to_string.one2'));
						_string = _string.replace(vm.$t('number_to_string.two1'), vm.$t('number_to_string.two2'));
						break;
					case 2:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.million1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.million2');
						else _string += vm.$t('number_to_string.million3');
						break;
					case 3:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.billion1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.billion2');
						else _string += vm.$t('number_to_string.billion3');
						break;
				}
				_string = _string.replace('  ', ' ');
				return _string;
			}

			function decimals_parser(_num) {
				var _first_num = _num.substr(0, 1);
				var _second_num = parseFloat(_num.substr(1, 1));
				var _string = ' ' + _first_num + _second_num;
				// if (_second_num == 1) _string += vm.$t('number_to_string.penny1');
				// else if (_second_num > 1 && _second_num < 5) _string += vm.$t('number_to_string.penny2');
				// else _string += vm.$t('number_to_string.penny3');
				_string+=' '
				if (name == 'UZS') _string += vm.$t('number_to_string.penny3')
				else _string += vm.$t('number_to_string.cent')
				return _string;
			}

			if (!_number || _number == 0) return false;
			if (typeof _number !== 'number') {
				_number = _number.replace(',', '.');
				_number = parseFloat(_number);
				if (isNaN(_number)) return false;
			}
			_number = _number.toFixed(4);
			if (_number.indexOf('.') != -1) {
				var _number_arr = _number.split('.');
				var _number = _number_arr[0];
				var _number_decimals = _number_arr[1];
			}
			var _number_length = _number.length;
			var _string = '';
			var _num_parser = '';
			var _count = 0;
			for (var _p = (_number_length - 1); _p >= 0; _p--) {
				var _num_digit = _number.substr(_p, 1);
				_num_parser = _num_digit + _num_parser;

				if ((_num_parser.length == 3 || _p == 0) && !isNaN(parseFloat(_num_parser))) {

					if (_num_parser !== "000") {
						_string = number_parser(_num_parser, _count) + _string;
					}

					_num_parser = '';
					_count++;

				}
			}
			// if (!_string.includes('сум') && !_string.includes('сўм')) {
			// 	_string += this.$t('number_to_string.currency3');
			// }

			if (name == 'UZS') {
				_string += 'сумов';
			} else if (name == 'USD') {
				_string += 'долларов';
			} else if (name == 'EUR') {
				_string += 'евро';
			} else if (name == 'RUB') {
				_string += 'рубль';
			} else if (name == 'GBR') {
				_string += 'фунт';
			}

			if (_number_decimals) _string += decimals_parser(_number_decimals);
			return _string.charAt(0).toUpperCase() + _string.slice(1);
		},
		number_to_string1(_number) {
			let vm = this;
			var _arr_numbers = new Array();
			_arr_numbers[1] = new Array('',
				vm.$t('number_to_string.1'),
				vm.$t('number_to_string.2'),
				vm.$t('number_to_string.3'),
				vm.$t('number_to_string.4'),
				vm.$t('number_to_string.5'),
				vm.$t('number_to_string.6'),
				vm.$t('number_to_string.7'),
				vm.$t('number_to_string.8'),
				vm.$t('number_to_string.9'),
				vm.$t('number_to_string.10'),
				vm.$t('number_to_string.11'),
				vm.$t('number_to_string.12'),
				vm.$t('number_to_string.13'),
				vm.$t('number_to_string.14'),
				vm.$t('number_to_string.15'),
				vm.$t('number_to_string.16'),
				vm.$t('number_to_string.17'),
				vm.$t('number_to_string.18'),
				vm.$t('number_to_string.19'));

			_arr_numbers[2] = new Array('', '',
				vm.$t('number_to_string.20'),
				vm.$t('number_to_string.30'),
				vm.$t('number_to_string.40'),
				vm.$t('number_to_string.50'),
				vm.$t('number_to_string.60'),
				vm.$t('number_to_string.70'),
				vm.$t('number_to_string.80'),
				vm.$t('number_to_string.90')
			);
			_arr_numbers[3] = new Array('',
				vm.$t('number_to_string.100'),
				vm.$t('number_to_string.200'),
				vm.$t('number_to_string.300'),
				vm.$t('number_to_string.400'),
				vm.$t('number_to_string.500'),
				vm.$t('number_to_string.600'),
				vm.$t('number_to_string.700'),
				vm.$t('number_to_string.800'),
				vm.$t('number_to_string.900'),
			);

			function number_parser(_num, _desc) {
				var _string = '';
				var _num_hundred = '';
				if (_num.length == 3) {
					_num_hundred = _num.substr(0, 1);
					_num = _num.substr(1, 3);
					_string = _arr_numbers[3][_num_hundred] + ' ';
				}
				if (_num < 20) _string += _arr_numbers[1][parseFloat(_num)] + ' ';
				else {
					var _first_num = _num.substr(0, 1);
					var _second_num = _num.substr(1, 2);
					_string += _arr_numbers[2][_first_num] + ' ' + _arr_numbers[1][_second_num] + ' ';
				}
				switch (_desc) {
					case 0:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.eur');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.eur');
						else _string += vm.$t('number_to_string.eur');
						break;
					case 1:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.thousand1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.thousand2');
						else _string += vm.$t('number_to_string.thousand3');
						_string = _string.replace(vm.$t('number_to_string.one1'), vm.$t('number_to_string.one2'));
						_string = _string.replace(vm.$t('number_to_string.two1'), vm.$t('number_to_string.two2'));
						break;
					case 2:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.million1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.million2');
						else _string += vm.$t('number_to_string.million3');
						break;
					case 3:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.billion1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.billion2');
						else _string += vm.$t('number_to_string.billion3');
						break;
				}
				_string = _string.replace('  ', ' ');
				return _string;
			}

			function decimals_parser(_num) {
				var _first_num = _num.substr(0, 1);
				var _second_num = parseFloat(_num.substr(1, 1));
				var _string = ' ' + _first_num + _second_num;
				_string+=' '
				if (_second_num == 1) _string += vm.$t('number_to_string.cent');
				else if (_second_num > 1 && _second_num < 5) _string += vm.$t('number_to_string.cent');
				else _string += vm.$t('number_to_string.cent');
				return _string;
			}

			if (!_number || _number == 0) return false;
			if (typeof _number !== 'number') {
				_number = _number.replace(',', '.');
				_number = parseFloat(_number);
				if (isNaN(_number)) return false;
			}
			_number = _number.toFixed(4);
			if (_number.indexOf('.') != -1) {
				var _number_arr = _number.split('.');
				var _number = _number_arr[0];
				var _number_decimals = _number_arr[1];
			}
			var _number_length = _number.length;
			var _string = '';
			var _num_parser = '';
			var _count = 0;
			for (var _p = (_number_length - 1); _p >= 0; _p--) {
				var _num_digit = _number.substr(_p, 1);
				_num_parser = _num_digit + _num_parser;

				if ((_num_parser.length == 3 || _p == 0) && !isNaN(parseFloat(_num_parser))) {

					if (_num_parser !== "000") {
						_string = number_parser(_num_parser, _count) + _string;
					}

					_num_parser = '';
					_count++;

				}
			}
			// if (!_string.includes('сум') && !_string.includes('сўм')) {
			// 	_string += this.$t('number_to_string.eur');
			// }

			if (_number_decimals) _string += decimals_parser(_number_decimals);
			return _string.charAt(0).toUpperCase() + _string.slice(1);
		},
	},
	async created() {
		this.loading = true
		// this.get()
		// this.kirim()
		let data = {
			limit: 100000,
			page: 1,
			value: ''
		}
		await WhDocument.getWithPrices(this.$route.params.id, data).then(res => {
			// if (this.$route.params.action === 'view') {
				this.item = res.data
				this.Id = res.data.id
			// }
			this.priceItems = res.data.whItems
			this.regDate = res.data.regDate
			this.loading = false
		})
		let d = {
			date: this.regDate
		}
		await WhDocument.getPrices(d).then(res => {
			this.prices = res.data
			this.loading = false
		})
	},
	watch: {
		totalItemSum: {
			handler(newValue) {
				this.param.totalItemSum = newValue;
				this.param.totalItemInText = this.number_to_string(Math.abs(newValue))
			}
		},
	}
}
</script>

<style scoped lang="scss">
.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}

.nakladnoyWholesale {
	margin: 0 20px;
}

@page  {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}
	.mt {
		padding-top: 200px !important;
	}
	.card {
		box-shadow: none;
	}
	#nakladnoyTableWrapper {
		display: block;
	}
	footer {
		page-break-after: always;
	}
}

.saldoInfoTexts {
	width: 88%;

	span {
		display: inline-block;
		width: 18%;
	}

	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 80%;
	}

	/*input.bottomBorderedInput:focus {
	border-color: green
	}*/
}


.signsOfAccountants {
	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 40%;
	}

	p {
		width: 40%;

		&.sign {
			text-align: center;
			font-size: 12px;
		}
	}
}

input.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

h6.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

#nakladnoyTableWrapper {
	.table {
		td, th {
			border: 1px solid black;
			vertical-align: middle;

			&.borderRightNone {
				border-right: none;
			}

			&.borderLeftNone {
				border-left: none;
			}

			&.borderTopNone {
				border-top: none;
			}

			&.borderBottomNone {
				border-bottom: none;
			}

			color: black;
		}

		#moldavianItemsHeader {
			th {
				font-size: 9px;
				border-bottom: none;
			}

			.width27 {
				width: 27%;
			}
		}

		#russianItemsHeader {
			th {
				font-size: 9px;
				border-top: none;
			}

			.greyText {
				color: #999999;
			}
		}

		.docItemRow {
			td {
				text-align: right;

				&.docItemUnit {
					text-align: center;
				}

				&:first-child {
					text-align: unset;
				}

				padding: 0 .5rem;
			}
		}

		th {
			font-size: 11px;
		}


		.moldavianText {
			font-weight: bold;
		}

		.fontWeightNormal {
			font-weight: normal;
		}

		tfoot {
			th, td {
				font-weight: bold;
				font-size: 11px;
				text-align: right;

				&.textAlignCenter {
					text-align: center;
				}

				&:first-child {
					text-align: unset;
				}

				padding: 0 .5rem;
			}
		}
	}
}

.customSize {
	font-size: 10px;
}

.customSizeItem {
	font-size: 12px;
}

.nobr {
	white-space: nowrap;
}

.strong {
	font-weight: bold;
}

#docUpperPart {
	p {
		margin-bottom: 0;
	}

	margin-bottom: .5rem;

	#docImgLogoName {
		margin-left: 32%;
		width: 300px;
		height: auto;
	}

	#docImgLogo {
		width: 180px;
		height: 70px;
	}

	#docUpperPartLeft {
		#docUpperPartTxt {
			margin-top: .5rem;
			display: inline-block;
			width: 30%;

			p {
				display: inline-block;
			}
		}

		#barcodeImgForSeria {
			cursor: pointer;
			display: inline-block;
			width: 30%;

			svg {
				vertical-align: bottom;
				width: 46mm !important;
				height: auto !important;

				g {
					text {
						font-size: 14px !important;
						transform: translateY(46px) !important;
					}
				}
			}
		}

		display: inline-block;
		width: 74%;

		#seriaInputForBarcode {
			display: inline-block;

			input {
				margin-left: .5rem;
				width: 10rem;
				height: 1.2rem;
			}
		}
	}

	#docUpperPartRight {
		display: inline-block;
		width: 26%;
		vertical-align: top;
		text-align: right;

		#rightPartTxt {
			font-size: 10px;
		}
	}
}
</style>
